export default function apiHeader() {
  let user = JSON.parse(localStorage.getItem("user"));
  if (user && user.jwt_token) {
    return {
      "Content-Type": 'application/json',
      Authorization: `${user.token_type} ${user.jwt_token}`,
    };
  } else {
    return {};
  }
}
